import { FormTextEditor } from '@Components/Form';
import { BusinessValueChainFormValues } from '@Router/ImpactsOnStakeholdersManagement/Containers/ImpactsOnStakeholdersFormProvider/types';
import { disabledFormInputStyles } from '@Components/Form/styles';
import { useWatch } from 'react-hook-form';

const BusinessValueChainsForm = () => {
  const { completedSection } =
    useWatch({
      name: 'businessValueChain',
    }) ?? ({} as BusinessValueChainFormValues);

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  return (
    <>
      <FormTextEditor
        name={`businessValueChain.descriptionTh`}
        label={'กรุณาอธิบายภาพรวมกิจกรรมในห่วงโซ่คุณค่าธุรกิจ (ไทย)'}
        inputProps={{ placeholder: 'กรุณาระบุ (ไทย)' }}
        required
        sx={isCompletedTh ? disabledFormInputStyles : undefined}
      />
      <FormTextEditor
        name={`businessValueChain.descriptionEn`}
        label={'กรุณาอธิบายภาพรวมกิจกรรมในห่วงโซ่คุณค่าธุรกิจ (อังกฤษ)'}
        inputProps={{ placeholder: 'กรุณาระบุ (อังกฤษ)' }}
        required
        sx={isCompletedEn ? disabledFormInputStyles : undefined}
      />
    </>
  );
};
export default BusinessValueChainsForm;
